import React from "react";
import { SortBy } from "../types/SortBy";
import DropdownSelect from "./DropdownSelect";
import { typeToString } from "../extensions/helpers";

interface FilterSortProps {
  sort: SortBy;
  setSort: (sort: SortBy) => void;
  productCount: number;
  /** Whether the left filter rail is showing — drives the button's pressed state. */
  isFilterOpen: boolean;
  onToggleFilter: () => void;
  /** Facet values currently selected, shown as a badge on the Filter button. */
  selectedFilterCount: number;
  /** Hidden when the category has nothing worth filtering on. */
  canFilter: boolean;
}

const FilterSort: React.FC<FilterSortProps> = ({
  sort,
  setSort,
  productCount,
  isFilterOpen,
  onToggleFilter,
  selectedFilterCount,
  canFilter,
}) => {
  return (
    // A ruled band between the page header and the grid: the Filter toggle on
    // the left, and the result count paired with the sort control on the right
    // so the two things that describe the same list sit together.
    <div className="browse-toolbar mb-6">
      {canFilter ? (
        <button
          type="button"
          className={`browse-filter-button ${
            isFilterOpen ? "browse-filter-button--open" : ""
          }`}
          onClick={onToggleFilter}
          aria-expanded={isFilterOpen}
        >
          {/* Slider icon, matching the toggle's meaning rather than a funnel —
              these are refinements, not a single narrowing. */}
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={1.8}
            strokeLinecap="round"
            className="h-4 w-4"
            aria-hidden="true"
          >
            <path d="M4 7h11M19 7h1M4 17h5M13 17h7" />
            <circle cx="17" cy="7" r="2" />
            <circle cx="11" cy="17" r="2" />
          </svg>
          Filter
          {selectedFilterCount > 0 && (
            <span className="browse-filter-button__badge">
              {selectedFilterCount}
            </span>
          )}
        </button>
      ) : (
        <span />
      )}

      <div className="browse-toolbar__right">
        <span className="browse-toolbar__count">
          {productCount} Result{productCount !== 1 ? "s" : ""}
        </span>
        <DropdownSelect
          selected={{ id: sort, name: typeToString(sort) ?? "" }}
          setSelected={(value) =>
            setSort(SortBy[value.id as keyof typeof SortBy])
          }
          options={Object.keys(SortBy).map((sb) => ({
            id: sb,
            name: typeToString(sb) ?? "",
          }))}
        />
      </div>
    </div>
  );
};

export default FilterSort;
